import { createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import { formatISO } from 'date-fns';
import { checkToken, addDays } from '../misc/utils'
import { RootState } from '../store'

// Misc
import { Iabtest } from '../misc/interface/abtest'

// Define the initial state usiEng that type
export const getInitialState = (): Iabtest => ({
    name: '',
	shopify_domain: '',
	status: '',
	// Update "end_at" If any modification
	duration: {value: 15, label: '15 days'},
	scheduled_at: '',
	// Update "duration" If any modification
	end_at: formatISO(addDays(Date.now(), 15)),
	test: [{
		name: 'Control',
		recipe: null,
		recipe_live: null,
		traffic: {value: 50, label: '50%'},
		id: '',
		theme_id: ''
	}],
	theme: {label: '', id: ''}
});

export const abtestCreate =  createAsyncThunk('abtestCreate', async (abtest: Iabtest, store) => {
	const token = await checkToken(store)

	const state = store.getState() as RootState
	const myshopifyDomain = state?.shopifyStore?.shopifyStore?.myshopifyDomain
	abtest.shopify_domain = myshopifyDomain || ''
	abtest.status = 'draft'
	
	const response = await fetch(`${process.env.REACT_APP_ENV === 'dev' ? process.env.REACT_APP_LOCAL_API_URL : process.env.REACT_APP_API_URL}/abtest`, {
		method: 'POST',
		credentials: 'include',
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(abtest)
	})
	
	return response.json()
})

export const abtestGetAll =  createAsyncThunk('abtestGetAll', async (_, store) => {
	const token = await checkToken(store)

	const response = await fetch(`${process.env.REACT_APP_ENV === 'dev' ? process.env.REACT_APP_LOCAL_API_URL : process.env.REACT_APP_API_URL}/abtest`, {
		method: 'GET',
		credentials: 'include',
		headers: {
			Authorization: `Bearer ${token}`,
		}
	})

	return response.json()
})

export const abtestGet =  createAsyncThunk('abtestGet', async (id: string, store) => {
	const token = await checkToken(store)

	const response = await fetch(`${process.env.REACT_APP_ENV === 'dev' ? process.env.REACT_APP_LOCAL_API_URL : process.env.REACT_APP_API_URL}/abtest/${id}`, {
		method: 'GET',
		credentials: 'include',
		headers: {
			Authorization: `Bearer ${token}`,
		}
	})

	return response.json()
})

export const abtestUpdate =  createAsyncThunk('abtestUpdate', async ({abtest, abtest_id}: {abtest: any, abtest_id: string}, store) => {
	const token = await checkToken(store)

	const response = await fetch(`${process.env.REACT_APP_ENV === 'dev' ? process.env.REACT_APP_LOCAL_API_URL : process.env.REACT_APP_API_URL}/abtest/${abtest_id}`, {
		method: 'PUT',
		credentials: 'include',
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(abtest)
	})

	return response.json()
})

export const abtestDelete =  createAsyncThunk('abtestDelete', async ({abtest_id}: { abtest_id: string}, store) => {
	const token = await checkToken(store)

	const response = await fetch(`${process.env.REACT_APP_ENV === 'dev' ? process.env.REACT_APP_LOCAL_API_URL : process.env.REACT_APP_API_URL}/abtest/${abtest_id}`, {
		method: 'DELETE',
		credentials: 'include',
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json'
		}
	})

	return response.json()
})


// ALSO USE FOR ADMIN INTERFACE
export const abtestGetAnalytics =  createAsyncThunk('abtestGetAnalytics', async (id: string, store) => {
	const token = await checkToken(store)

	const response = await fetch(`${process.env.REACT_APP_ENV === 'dev' ? process.env.REACT_APP_LOCAL_API_URL : process.env.REACT_APP_API_URL}/abtest/analytics/${id}`, {
		method: 'GET',
		credentials: 'include',
		headers: {
			Authorization: `Bearer ${token}`,
		}
	})

	return response.json()
})

export const getThemes =  createAsyncThunk('getThemes', async (_, store) => {

  	const token = await checkToken(store)

	const response = await fetch(`${process.env.REACT_APP_ENV === 'dev' ? process.env.REACT_APP_LOCAL_API_URL : process.env.REACT_APP_API_URL}/store/themes`, {
		headers: {
			Authorization: `Bearer ${token}`
		},
		method: 'GET',
		credentials: 'include',
	})

	return response.json()
})

export const generateToken =  createAsyncThunk('generateToken', async ({var_id, abtest_id}: {var_id: string, abtest_id: string}, store) => {
	const token = await checkToken(store)

	const state = store.getState() as RootState
	const primaryDomain = state?.shopifyStore?.shopifyStore?.primaryDomain

	const response = await fetch(`${process.env.REACT_APP_ENV === 'dev' ? process.env.REACT_APP_LOCAL_API_URL : process.env.REACT_APP_API_URL}/abtest/t?domain=${primaryDomain}`, {
		headers: {
			'x-var-id': var_id,
			'x-ab-id': abtest_id,
			Authorization: `Bearer ${token}`
		},
		method: 'GET',
		credentials: 'include',
	})

	return response.json()
})

export const abtestSlice = createSlice(
	{
		name: 'abtest',
		initialState: {},
		reducers: {},
		extraReducers(builder) {
			builder
			// abtestCreate
			.addCase(abtestCreate.pending, (state) => {
				console.log("abtestCreate : pending")
			})
			.addCase(abtestCreate.fulfilled, (state) => {
				console.log("abtestCreate : fulfilled")
			})
			.addCase(abtestCreate.rejected, (state) => {
				console.log("abtestCreate : rejected")
			})

			// abtestGetAll
			.addCase(abtestGetAll.fulfilled, (state) => {
				console.log("abtestGetAll : fulfilled")
			})

			// abtestGet
			.addCase(abtestGet.fulfilled, (state) => {
				console.log("abtestGet : fulfilled")
			})

			// abtestGetAnalytics
			.addCase(abtestGetAnalytics.fulfilled, (state) => {
				console.log("abtestGetAnalytics : fulfilled")
			})

			// abtestUpdate
			.addCase(abtestUpdate.pending, (state) => {
				console.log("abtestUpdate : pending")
			})
			.addCase(abtestUpdate.fulfilled, (state) => {
				console.log("abtestUpdate : fulfilled")
			})
			.addCase(abtestUpdate.rejected, (state) => {
				console.log("abtestUpdate : rejected")
			})

			// getThemes
			.addCase(getThemes.fulfilled, (state) => {
				console.log("getThemes : fulfilled")
			})

			// generateToken
			.addCase(generateToken.fulfilled, (state) => {
				console.log("generateToken : fulfilled")
			})
		}
	}
)

export default abtestSlice.reducer
